<div
    [formGroup]="_form()"
    class="w-full"
>
    <p-selectButton
        [formControlName]="id()"
        [options]="optionsTranslated()"
        optionLabel="key"
        optionValue="value"
        styleClass="label-bold"
        [allowEmpty]="clear()"
        [unselectable]="unselectable()"
    >
    </p-selectButton>
</div>
